export default class OperationDataTypeConst {
    static INSERT = 0
    static UPDATE = 1
    static DELETE = 2
  }
  